import { Component, OnInit, Input, Output, EventEmitter, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { AppUrls } from '../../../utility/appurls';
import { GenericLookupForm } from '../generic-lookup-form';
import { MaskUtility } from '../../../utility/mask-utility';
import { MaskConfig } from '../../../utility/mask-config';
import { Observable } from 'rxjs';
import { FieldLabelConstants } from 'projects/bis-shared/src/lib/utility/field-label-constants';
import { DynamicFormsService } from '../../../dynamic-forms/services/dynamic-forms/dynamic-forms.service';
import { UserInputOptionType } from 'projects/bis-shared/src/lib/shared-models/user-input-option-type';
import { GenericInputComponent } from '../../../dynamic-forms/dynamic-form-inputs/generic-input/generic-input.component';
import { SelectInputComponent } from '../../../dynamic-forms/dynamic-form-inputs/select-input/select-input.component';
import { TextInputComponent } from '../../../dynamic-forms/dynamic-form-inputs/text-input/text-input.component';
import { DynamicFormLoadDirective } from '../../../dynamic-forms/directives/dynamic-form-structural.directive';

@Component({
  selector: 'app-insurer-lookup-form',
  templateUrl: './insurer-lookup-form.component.html',
  styleUrls: ['./insurer-lookup-form.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports:[GenericInputComponent, SelectInputComponent, DynamicFormLoadDirective, TextInputComponent],
})
export class InsurerLookupFormComponent extends GenericLookupForm implements OnInit {
  private dynamicFormsService = inject(DynamicFormsService);

  @Output() enterKey: EventEmitter<any> = new EventEmitter();
  @Input() events: Observable<void>;
  formLoaded = false;
  AppUrls = AppUrls;
  feinMaskConfig: MaskConfig;
  inIdMaskConfig = MaskUtility.getEntityIdMask('IN');
  FieldLabelConstants = FieldLabelConstants;

  
 

  constructor() {
    super();
  }

  ngOnInit() {
    this.dynamicFormsService.getFormGroupForModel('insurerLookup').subscribe(formInfo => {
      this.formInfo = formInfo;
      this.form = formInfo.formGroup;
      this.formLoaded = true;
    });
  }

  search() {
    this.enterKey.emit();
  }

  onFeinChange() {
    this.feinMaskConfig = MaskUtility.getFEINMask();
  }

  public isValid(): boolean {
    return this.form && this.form.valid;
  }

  public reset(): void {
    this.form.reset({
      nameSearchOptionType: UserInputOptionType.Contains,
    });
  }
}
